export default __webpack_public_path__ + "static/media/Foto galrija 11.35a4d8de.jpg";